import ApiService from '@/services/api.service'
import type {
  ClientAssistantListResponse,
  RootAccessData,
  TermsConfig,
} from '@/types/services/root'
import type { AxiosResponse } from 'axios'

export interface UpdateRootPayload {
  name: string // name of account (aka fund name, aka holding name, aka whatever name)
  logo_full_url?: string // path to logo
  logo_icon_url?: string
  color_primary?: string
}

export default class RootService {
  // NOT USED
  /**
   * Get Root
   **/
  static getRoot(rootId: string): Promise<AxiosResponse<any>> {
    return ApiService.get(`/api/v1/roots/${rootId}`)
  }

  // NOT USED
  /**
   * Update Root
   **/
  static updateRoot(
    rootId: string,
    data: UpdateRootPayload
  ): Promise<AxiosResponse<any>> {
    return ApiService.put(`/api/v1/roots/${rootId}`, data)
  }

  static getAccessData(): Promise<AxiosResponse<RootAccessData[]>> {
    return ApiService.get('/api/v2/root/access_data')
  }

  static acceptTerms(
    entityId: string
  ): Promise<AxiosResponse<{ success: boolean; accepted_at: string }>> {
    return ApiService.post('/api/v2/root/referrer_terms/accept', {
      entity_id: entityId,
    })
  }

  static getTermsContent(
    entityId: string
  ): Promise<AxiosResponse<TermsConfig>> {
    return ApiService.get(`/api/v2/root/referrer_terms/${entityId}`)
  }

  static getClientAssistants(
    clientRelationId: string
  ): Promise<AxiosResponse<ClientAssistantListResponse>> {
    return ApiService.get(
      `/api/v2/root/user-relations/${clientRelationId}/assistants`
    )
  }

  static assignAssistantToClient(
    clientRelationId: string,
    data: {
      assistant_relation_id: string
      notify_assistant?: boolean
    }
  ): Promise<AxiosResponse> {
    return ApiService.post(
      `/api/v2/root/user-relations/${clientRelationId}/assistant`,
      data
    )
  }

  static closeAssistantAccess(
    clientRelationId: string,
    assistantRelationId: string
  ): Promise<AxiosResponse> {
    return ApiService.patch(
      `/api/v2/root/user-relations/${clientRelationId}/assistant/${assistantRelationId}/close`,
      {}
    )
  }
}
